import React from "react"
import PropTypes from "prop-types"

import Options from "../Options/Options"
import styles from "./Question.module.scss"

const Question = ({ question, number, quesId, index, ...rest }) => (
    <>
        {question && (
            <div className={styles.questContainer}>
                <h3>Question {number}</h3>
                <h2>{question}</h2>
                <ul>
                    <Options
                        quesId={quesId}
                        number={number}
                        index={index}
                        {...rest}
                    />
                </ul>
            </div>
        )}
    </>
)

Question.propTypes = {
    question: PropTypes.string.isRequired,
    quesId: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
}

export default Question
